import { styled } from '@mui/material/styles';
import { getDrugTestThemeTokens } from '../themeTokens';
import type { WebhookProcessingTone } from './types';

export const ProcessingChip = styled('span', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: WebhookProcessingTone }>(({ theme, tone }) => ({
  display: 'inline-flex',
  padding: '2px 8px',
  borderRadius: 4,
  fontSize: 11,
  fontWeight: 600,
  ...getDrugTestThemeTokens(theme).processingChip[tone],
}));
